import { AxiosRequest } from "../common/axios-request";
import {
  ASSOCIATE_RESCHEDULE_ADD_BOOKING_COURTS,
  ASSOCIATE_RESCHEDULE_ADD_BOOKING_SLOTS,
  ASSOCIATE_RESCHEDULE_CANCEL_SLOTS,
  ASSOCIATE_RESCHEDULE_DELETE_COURT,
  ASSOCIATE_RESCHEDULE_UPDATE_END_DATE,
  CANCLE_ASSOCIATE_BOOKING,
  COLLECT_ASSOCIATE_INVOICE_PAYMENT,
  CREATE_ASSOCIATE_BOOKING,
  DOWNLOAD_ASSOCIATE_BOOKING_LIST,
  DOWNLOAD_ASSOCIATE_INVOICE,
  GENERATE_ASSOCIATE_INVOICE,
  GET_ASSOCIATE_BOOKING_AMOUNT,
  GET_ASSOCIATE_BOOKING_DETAILS,
  GET_ASSOCIATE_BOOKING_LIST,
  GET_GROUP_SLOTS,
  REFUND_ASSOCIATE_BOOKING,
  PRINT_ASSOCIATE_SUMMARY,
} from "../common/constant";

const GetAssociateBookingAmount = (payload: any) => {
  return AxiosRequest.post(GET_ASSOCIATE_BOOKING_AMOUNT, payload);
};

const CreateAssociateBooking = (payload: any) => {
  return AxiosRequest.post(CREATE_ASSOCIATE_BOOKING, payload);
};

const GetAssociateBookingList = (data: any) => {
  const {
    page,
    key,
    fromDate,
    toDate,
    facilityId,
    sportId,
    bookingStatus,
    paymentStatus,
    orderByCol,
    orderBy,
  } = data;
  return AxiosRequest.get(
    GET_ASSOCIATE_BOOKING_LIST(
      page,
      key,
      fromDate,
      toDate,
      facilityId,
      sportId,
      bookingStatus,
      paymentStatus,
      orderByCol,
      orderBy
    )
  );
};

const DownloadAssociateBookingList = (params: any) => {
  const {
    key,
    fromDate,
    toDate,
    facilityId,
    sportId,
    bookingStatus,
    paymentStatus,
    orderByCol,
    orderBy,
  } = params;
  return AxiosRequest.get(
    DOWNLOAD_ASSOCIATE_BOOKING_LIST(
      key,
      fromDate,
      toDate,
      facilityId,
      sportId,
      bookingStatus,
      paymentStatus,
      orderByCol,
      orderBy
    )
  );
};

const GetAssociateBookingDetails = (id: string, bookingDate: string = "") => {
  return AxiosRequest.get(GET_ASSOCIATE_BOOKING_DETAILS(id, bookingDate));
};

const CancelAssociateBooking = (id: string, payload: any) => {
  return AxiosRequest.put(CANCLE_ASSOCIATE_BOOKING(id), payload);
};

const GenerateAssociateInvoice = (
  bookingId: string,
  invoiceId: string,
  payload: any
) => {
  return AxiosRequest.put(
    GENERATE_ASSOCIATE_INVOICE(bookingId, invoiceId),
    payload
  );
};

const CollectAssociateInvoicePayment = (
  bookingId: string,
  invoiceId: string
) => {
  return AxiosRequest.put(
    COLLECT_ASSOCIATE_INVOICE_PAYMENT(bookingId, invoiceId),
    ""
  );
};

const DownloadAssociateInvoice = (bookingId: string, invoiceId: string) => {
  return AxiosRequest.get(DOWNLOAD_ASSOCIATE_INVOICE(bookingId, invoiceId));
};

const PrintAssociateSummary = (bookingId: string) => {
  return AxiosRequest.get(PRINT_ASSOCIATE_SUMMARY(bookingId));
};

const RefundAssociateBooking = (bookingId: string, payload: any) => {
  return AxiosRequest.put(REFUND_ASSOCIATE_BOOKING(bookingId), payload);
};

const GetGroupSlots = (bookingId: string, IsReschedule: string) => {
  return AxiosRequest.get(GET_GROUP_SLOTS(bookingId, IsReschedule));
};

const AssociateRescheduleCancelSlots = (bookingId: string, payload: any) => {
  return AxiosRequest.put(
    ASSOCIATE_RESCHEDULE_CANCEL_SLOTS(bookingId),
    payload
  );
};

const AssociateRescheduleUpdateEndDate = (bookingId: string, payload: any) => {
  return AxiosRequest.put(
    ASSOCIATE_RESCHEDULE_UPDATE_END_DATE(bookingId),
    payload
  );
};

const AssociateRescheduleDeleteCourt = (bookingId: string, payload: any) => {
  return AxiosRequest.put(
    ASSOCIATE_RESCHEDULE_DELETE_COURT(bookingId),
    payload
  );
};

const AssociateRescheduleAddBookingSlots = (
  bookingId: string,
  payload: any
) => {
  return AxiosRequest.put(
    ASSOCIATE_RESCHEDULE_ADD_BOOKING_SLOTS(bookingId),
    payload
  );
};

const AssociateRescheduleAddBookingCourts = (
  bookingId: string,
  payload: any
) => {
  return AxiosRequest.put(
    ASSOCIATE_RESCHEDULE_ADD_BOOKING_COURTS(bookingId),
    payload
  );
};

export {
  GetAssociateBookingAmount,
  CreateAssociateBooking,
  GetAssociateBookingList,
  DownloadAssociateBookingList,
  GetAssociateBookingDetails,
  CancelAssociateBooking,
  GenerateAssociateInvoice,
  CollectAssociateInvoicePayment,
  DownloadAssociateInvoice,
  RefundAssociateBooking,
  GetGroupSlots,
  AssociateRescheduleCancelSlots,
  AssociateRescheduleUpdateEndDate,
  AssociateRescheduleDeleteCourt,
  AssociateRescheduleAddBookingSlots,
  AssociateRescheduleAddBookingCourts,
  PrintAssociateSummary,
};
